document.addEventListener('DOMContentLoaded', () => {
  /* FAQs */
  faqs();
});

/**
 * Toggles the visibility of FAQ answers on user interaction.
 * When a question is clicked, the function closes all other questions
 * by removing their 'is-active' class, and toggles the clicked question's
 * 'is-active' class to expand or collapse its answer.
 */
function faqs() {
  const faqSections = document.querySelectorAll('.js-faqs-section');

  faqSections.forEach(faqSection => {
    const questions = faqSection.querySelectorAll('.question-js');

    questions.forEach(question => {
      question.addEventListener('click', () => {
        // Close all other questions
        questions.forEach(sItem => {
          if (sItem !== question) { // Skip the current question
            sItem.classList.remove('is-active');
          }
        });

        // Toggle the current question
        question.classList.toggle('is-active');
      });
    });
  });
}
